const Events = ({ children }) => {
    return (
        <div className="main-content__calendar">
            {children}
        </div>
    );
};

export default Events;
